export const resolveRegionString = (region) => {
    if (window.__ENV__ === 'PRODUCTION') {
        switch(region) {
            case "EU_WEST_1":
              return "EU"
            case 'US_EAST_1':
            default:
              return "US"
        }
    } else {
        return 'QA'
    }
}

export const resolveClientByRegion = (region, usClient, euClient) => {
    switch(region) {
        case "EU":
            return euClient;
        case "QA":
        case "US":
        default:
            return usClient
    }
}